export const akademiInfoCard = [
  {
    id: 1,
    title: "Mengajar serta membangun profesionalitas",
    subtitle:
      "Bukan hanya keterampilan mengajar, tetapi juga membangun profesionalitas untuk jangka panjang.",
    info: [
      {
        bold: { text: "" },
        normal: ["<b>Pedagogi: </b>Teknik mengajar kelas dunia berbasis data"]
      },
      {
        bold: { text: "" },
        normal: [
          "<b>Teknik memotivasi:  </b>Keterampilan mengajar dan membangun interaksi dua arah"
        ]
      },
      {
        bold: { text: "" },
        normal: [
          "<b>Teknologi terkini: </b>Fasilitas agar mengajar jadi menyenangkan"
        ]
      },
      {
        bold: { text: "" },
        normal: [
          "<b>Profesionalisme: </b>Pengembangan berkelanjutan & rekan kerja suportif"
        ]
      }
    ]
  }
];
